import { EuiLoadingSpinner } from '@elastic/eui';

import cn from 'classnames';
import './styles.scss';

export interface ButtonProps {
  readonly onClick: () => void;
  readonly isLoading?: boolean;
  readonly children: string | JSX.Element;
  readonly disabled?: boolean;

  readonly big?: boolean;
  readonly secondary?: boolean;
  readonly secondaryOutline?: boolean;
  readonly testId?: string;
  readonly className?: string;
}

export const Button = ({
  isLoading,
  disabled,
  children,
  onClick,
  big,
  secondary,
  secondaryOutline,
  testId,
  className = undefined,
}: ButtonProps): JSX.Element => {
  const ButtonStyle = cn([
    className,
    'customButton',
    { 'customButton--disabled': disabled },
    { 'customButton--big': big },
    { 'customButton--secondary': secondary },
    { 'customButton--secondaryOutline': secondaryOutline },
  ]);

  return (
    <button test-id={testId} className={ButtonStyle} onClick={onClick} disabled={disabled}>
      {!isLoading ? children : <EuiLoadingSpinner size="m" />}
    </button>
  );
};
